import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import SvgIcon from "@mui/material/SvgIcon";
import { grey } from "@mui/material/colors";
import { useState } from "react";
import { theme } from "../styles/theme";
import CloseModalButton from "./CloseModalButton";
import MapBandsLegend from "./MapBandsLegend";
import MapFilterContainer from "./MapFilterContainer";
import MapLocationsLegend from "./MapLocationsLegend";
import MapPopover from "./MapPopover";
import FilterIcon from "./icons/FilterIcon";

export default function MapFilterLegendContainer({
  categories,
  regions,
  zipcodes,
  contentFullscreen,
  currentView,
}) {
  const [openElement, setOpenElement] = useState(null);
  const [filterDialogOpen, setFilterDialogOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleToggle = (menuId) => {
    if (openElement === menuId) {
      setOpenElement(null);
    } else {
      setOpenElement(menuId);
    }
  };

  const handleFilterDialogOpen = () => {
    setFilterDialogOpen(true);
  };

  const handleFilterDialogClose = () => {
    setFilterDialogOpen(false);
  };

  return (
    <>
      <Box sx={filterLegendStyle}>
        {currentView === "locations" && (
          <>
            <IconButton
              size="small"
              variant="square-secondary"
              onClick={handleFilterDialogOpen}
              sx={{ display: { md: "none" } }}
            >
              <SvgIcon>
                <FilterIcon />
              </SvgIcon>
            </IconButton>
            <MapPopover
              label="Filter"
              buttonId="filter-button"
              menuId="filter-menu"
              contentFullscreen={contentFullscreen}
              isOpen={openElement === "filter-menu"}
              onToggle={handleToggle}
            >
              <CloseModalButton handleToggle={handleToggle} />
              <Box sx={MapFilterWrapperStyles}>
                <MapFilterContainer
                  categories={categories}
                  regions={regions}
                  zipcodes={zipcodes}
                  handleToggle={handleToggle}
                />
              </Box>
            </MapPopover>
          </>
        )}
        <MapPopover
          label="Legende"
          buttonId="legend-button"
          menuId="legend-menu"
          contentFullscreen={contentFullscreen}
          isOpen={openElement === "legend-menu"}
          onToggle={handleToggle}
        >
          <CloseModalButton handleToggle={handleToggle} />
          {currentView === "locations" ? (
            <MapLocationsLegend categories={categories} />
          ) : (
            <MapBandsLegend />
          )}
        </MapPopover>
      </Box>
      <Dialog
        fullScreen={fullScreen}
        open={filterDialogOpen}
        onClose={handleFilterDialogClose}
      >
        <Box
          sx={{
            zIndex: "500",
            transform: "translate(-1.25rem, 1.25rem)",
          }}
        >
          <CloseModalButton handleToggle={handleFilterDialogClose} />
        </Box>
        <DialogContent>
          <MapFilterContainer
            categories={categories}
            regions={regions}
            zipcodes={zipcodes}
          />
        </DialogContent>
        <DialogActions sx={{ mb: 3 }}>
          <Button
            variant="contained"
            fullWidth
            color="secondary"
            onClick={handleFilterDialogClose}
          >
            Filtern
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

const filterLegendStyle = {
  padding: "0.25rem",
  backgroundColor: grey[300],
  zIndex: "50",
  position: "absolute",
  right: "0",
  top: "0",
  transform: "translate(-0.5rem, 0.5rem)",
  display: "flex",
  flexDirection: "column",
  gap: "0.25rem",
};

const MapFilterWrapperStyles = {
  height: "30rem",
  overflowY: "scroll",
  [theme.breakpoints.up("lg")]: {
    height: "auto",
    overflow: "visible",
  },
};
